import React from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { useParams } from 'react-router'
import { shallowEqual, useSelector } from 'react-redux'
import RpqsDocumentsPanel from '../documents/RpqsDocumentsPanel'

const RpqsDocumentsApp = () => {
    const {
        rpqs,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
    }), shallowEqual)

    const { annee, idCollectivite } = useParams()

    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: rpqs.year || `${i18n.year} ${i18n.unknown}`,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: rpqs.name || i18n.unknown,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `rpqs/${annee}/collectivite/${idCollectivite}/documents`,
    }], [rpqs, annee, idCollectivite])

    return <RpqsDocumentsPanel year={annee} collectivityId={idCollectivite} />
}

export default RpqsDocumentsApp
